import React from "react";
import ActionHistory from "./ActionHistory";
import useFetch from "../../../../../hooks/useFetch";
import InitialValueRendering from "../../../../global/InitialValueRendering";

export default function ModalActionHistory() {
  const { value, loading, error } = useFetch("/api/v1/order_action_histories/");

  if (error || loading) {
    return <InitialValueRendering error={error} loading={loading} />;
  }

  if (!value?.length) return <div>Nothing to show</div>;

  return value.map((variable) => (
    <ActionHistory
      key={variable.order_id}
      order_id={variable.order_id}
      id_order={variable.id_order}
    />
  ));
}
